import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup, Glyphicon } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IBaseState } from "src/interfaces";
import { ISolarGeneratedProps } from "./interfaces";

export default class SolarGenerated extends Component<ISolarGeneratedProps, IBaseState> {
  public constructor(props: ISolarGeneratedProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleSolarGeneratedChanged = this.handleSolarGeneratedChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset>
          <legend>Solar Generated</legend>
          <LoadingStatus width={25} height={25} singular={true} />
        </fieldset>
      );
    }

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 6;
    const smInputWidthR = 6;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    const netSolarUsage = this.props.solarGenerated - this.props.solarReceived;

    return (
      <fieldset className="fieldset-right">
        <legend>Solar Generated</legend>
        <FormGroup bsSize="small" controlId="solarGenerated">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Total Solar Generated
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarGenerated}
              onChange={this.handleSolarGeneratedChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="solarReceived">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            <Glyphicon glyph="glyphicon glyphicon-minus" /> Received by Grid
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarReceived}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          xs={xsInputWidthR}
          smOffset={smLabelWidthR}
          sm={smInputWidthR}
          mdOffset={mdLabelWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="solarUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Net Solar Used
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={netSolarUsage}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }

  private handleSolarGeneratedChanged(e: any) {
    this.props.solarGeneratedChanged(e);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/singlerate/SolarGenerated.tsx